// components/CaseStudyWrapper.tsx
import { ReactNode } from 'react';

import { Footer } from '../../../../modules/footer';
import { CaseStudyNav } from './CaseStudyNav';
import HeroSection from './HeroSection';

interface CaseStudyWrapperProps {
  backgroundColor: string;
  backgroundImage: string;
  backgroundPosition?:
    | 'object-bottom'
    | 'object-center'
    | 'object-left-bottom'
    | 'object-left-top'
    | 'object-left'
    | 'object-right-bottom'
    | 'object-right-top'
    | 'object-right'
    | 'object-top';
  children: ReactNode;
  className?: string;
  heading: string;
  headingColor?: string;
  hoverTextColor: string;
  mobileBackgroundImage: string;
  mobileBackgroundPosition?:
    | 'object-bottom'
    | 'object-center'
    | 'object-left-bottom'
    | 'object-left-top'
    | 'object-left'
    | 'object-right-bottom'
    | 'object-right-top'
    | 'object-right'
    | 'object-top';
  mobileOverlayImages?: Array<{
    src: string;
    alt: string;
    className?: string;
    width?: number;
    height?: number;
  }>;
  nextLink: string;
  overlayImages?: Array<{
    src: string;
    alt: string;
    className?: string;
    width?: number;
    height?: number;
  }>;
}

export const CaseStudyWrapper = ({
  children,
  mobileBackgroundImage,
  backgroundImage,
  heading,
  headingColor = 'text-white',
  backgroundColor,
  nextLink,
  hoverTextColor,
  backgroundPosition = 'object-center',
  mobileBackgroundPosition = 'object-center',
  overlayImages,
  mobileOverlayImages,
}: CaseStudyWrapperProps) => {
  return (
    <>
      <HeroSection
        mobileBackgroundImage={mobileBackgroundImage}
        backgroundImage={backgroundImage}
        heading={heading}
        headingColor={headingColor}
        backgroundColor={backgroundColor}
        mobileBackgroundPosition={mobileBackgroundPosition}
        backgroundPosition={backgroundPosition}
        overlayImages={overlayImages}
        mobileOverlayImages={mobileOverlayImages}
      />
      <div className="relative pt-[100dvh]" style={{ zIndex: 10 }}>
        {children}
      </div>
      <CaseStudyNav nextLink={nextLink} hoverTextColor={hoverTextColor} />
      <Footer />
    </>
  );
};
